import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=aed37a10&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=aed37a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed37a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aed37a10')) {
      api.createRecord('aed37a10', component.options)
    } else {
      api.reload('aed37a10', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=aed37a10&scoped=true&", function () {
      api.rerender('aed37a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8fRnqRO5PF26x/JS/comp/GuestBoxKids.vue"
export default component.exports